import { useState } from "react";
import { loginApi } from "../../../apis/apis.hrm/apisUsers";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHooksAuth } from "../../../hooks";

const initialValues = {
    email:    "",
    password: "",
};

const validationSchema = Yup.object({
    email:    Yup.string().email("Formato de correo inválido").required("El correo es requerido"),
    password: Yup.string().required("La contraseña es requerida"),
});

const fieldCls = "w-full rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/30 text-sm px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-colors backdrop-blur-sm";
const errorCls = "mt-1.5 flex items-center gap-1.5 text-xs text-red-300";

export function FragmentLoginForm() {
    const [status, setStatus]         = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { login } = useHooksAuth();

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (formValue) => {
            setStatus(false);
            try {
                const response = await loginApi(formValue);
                const { access } = response;
                login(access);
            } catch (error) {
                setStatus(true);
                console.error(error);
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} noValidate className="space-y-5">

            {/* Error alert */}
            {status && (
                <div className="flex items-start gap-3 rounded-xl bg-red-500/20 border border-red-500/30 px-4 py-3 text-sm text-red-200">
                    <i className="fas fa-exclamation-triangle mt-0.5 flex-shrink-0"></i>
                    <span>Credenciales incorrectas. Por favor, intenta nuevamente.</span>
                    <button
                        type="button"
                        onClick={() => setStatus(false)}
                        className="ml-auto text-red-300 hover:text-red-100 transition-colors"
                        aria-label="Cerrar"
                    >
                        <i className="fas fa-times text-xs"></i>
                    </button>
                </div>
            )}

            {/* Email */}
            <div>
                <label htmlFor="email" className="block text-xs font-semibold text-blue-200/80 uppercase tracking-wide mb-1.5">
                    Correo electrónico
                </label>
                <div className="relative">
                    <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/40">
                        <i className="far fa-envelope text-sm"></i>
                    </span>
                    <input
                        id="email"
                        type="email"
                        name="email"
                        autoComplete="email"
                        placeholder="correo@ejemplo.com"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`${fieldCls} pl-10 ${formik.touched.email && formik.errors.email ? "border-red-400/60 focus:ring-red-400" : ""}`}
                    />
                </div>
                {formik.touched.email && formik.errors.email && (
                    <p className={errorCls}>
                        <i className="fas fa-info-circle"></i>
                        {formik.errors.email}
                    </p>
                )}
            </div>

            {/* Password */}
            <div>
                <label htmlFor="password" className="block text-xs font-semibold text-blue-200/80 uppercase tracking-wide mb-1.5">
                    Contraseña
                </label>
                <div className="relative">
                    <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/40">
                        <i className="fas fa-lock text-sm"></i>
                    </span>
                    <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        autoComplete="current-password"
                        placeholder="••••••••"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`${fieldCls} pl-10 pr-10 ${formik.touched.password && formik.errors.password ? "border-red-400/60 focus:ring-red-400" : ""}`}
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3.5 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70 transition-colors"
                        aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                    >
                        <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"} text-sm`}></i>
                    </button>
                </div>
                {formik.touched.password && formik.errors.password && (
                    <p className={errorCls}>
                        <i className="fas fa-info-circle"></i>
                        {formik.errors.password}
                    </p>
                )}
            </div>

            {/* Submit */}
            <button
                type="submit"
                disabled={formik.isSubmitting}
                className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 hover:bg-blue-500 active:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold text-sm px-4 py-3.5 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-transparent shadow-lg shadow-blue-500/25"
            >
                {formik.isSubmitting ? (
                    <>
                        <span className="h-4 w-4 rounded-full border-2 border-white border-t-transparent animate-spin"></span>
                        Iniciando sesión...
                    </>
                ) : (
                    <>
                        <i className="fas fa-sign-in-alt"></i>
                        Iniciar sesión
                    </>
                )}
            </button>
        </form>
    );
}
